import React from 'react'

export const ModalUploadLoader = () => {
  return (
    <div className='modal-upload-loader position-absolute'>
      <span className='modal-upload-loader__spinner mx-auto position-absolute rounded-circle'></span>
    </div>
  )
}
